export function getWeekDayName(weekDayId: number): string {
    const weekDays: string[] = ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'];
    return weekDays[weekDayId - 1];
}
